"use client";
import React, { createContext, useContext, ReactNode } from "react";

export type ServiceItemDef = {
  id: string;
  icon?: string;
  defaultTitle?: string;
  defaultDescription?: string;
};

type ServicesData = {
  items: ServiceItemDef[];
};

const defaultData: ServicesData = {
  items: [
    { id: "teamAugmentation", icon: undefined },
    { id: "itConsult", icon: undefined },
    { id: "networkSetup", icon: undefined },
    { id: "dataBackup", icon: undefined },
    { id: "itAudit", icon: undefined },
    { id: "techSolutions", icon: undefined },
    { id: "codeCrafters", icon: undefined },
    { id: "byteGenius", icon: undefined },
    { id: "netNinjas", icon: undefined },
  ],
};

const ServicesDataContext = createContext<ServicesData>(defaultData);

export const ServicesDataProvider = ({ children, value }: { children: ReactNode; value?: Partial<ServicesData> }) => {
  const merged: ServicesData = {
    ...defaultData,
    ...value,
    items: value?.items ?? defaultData.items,
  };
  return <ServicesDataContext.Provider value={merged}>{children}</ServicesDataContext.Provider>;
};

export const useServicesData = (): ServicesData => {
  const ctx = useContext(ServicesDataContext);
  if (!ctx) throw new Error("useServicesData must be used within ServicesDataProvider");
  return ctx;
};


